export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0011.cb7fe6c.jpg";